export default __webpack_public_path__ + "static/media/settings.af6ac5cf.png";